import React from 'react';
import Alert from 'reactstrap/lib/Alert';

interface OpenIdErrorProps {
	errorMessage?: string;
}

/**
 * Basic component to display an error message for when an error occurs when trying to do an OpenId authentication
 */
export default function OpenIdError(props?: OpenIdErrorProps) {
	return (
		<Alert color="warning">
			<strong>
				An error occurred when trying to log you in using OpenId.
				<p />
				{props?.errorMessage ? (
					<>
						{props.errorMessage}
						<p />
					</>
				) : null}
			</strong>
			<a href="/login">Click here to try again.</a>
		</Alert>
	);
}

/**
 * Component to display the error message that OpenId is unavailable.
 */
export const OpenIdOffline = () => <OpenIdError errorMessage="Open ID is currently unavailable." />;
